<button
  (taInteract)="interact.emit()"
  [attr.disabled]="disabled ? true : undefined"
  [type]="type"
  [class.ph--6]="!icon && !inline"
  [class.ph--2]="icon"
  [class.icon]="icon"
  [class.w--100]="full"
  [ngStyle]="{'min-width': inline ? '0': '' }"
  [ngClass]="class"
>
  <span [taTooltipStatic]="disabled ? disabledTooltipMessage : null">
      <ng-content></ng-content>
  </span>
</button>
